import { useQuery } from '@apollo/client/react';
import { useAuth } from 'react-oidc-context';
import { hasAnyRelevantRole } from '../utils/user';
import { DOCTOR_HAS_AIS_QUERY } from './useDoctorHasAis.gql';

export const useDoctorHasAis = (doctorId: string): boolean => {
  const auth = useAuth();
  const hasAnyRole = hasAnyRelevantRole(auth.user);

  const { data } = useQuery(DOCTOR_HAS_AIS_QUERY, {
    variables: {
      id: doctorId,
    },
    fetchPolicy: 'cache-and-network',
    skip: !doctorId || !hasAnyRole,
  });

  return data?.doctor?.hasAis === true;
};
